import {
  TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  USER_ID_KEY,
  DEVICE_ID_KEY,
  WALLET_KEY,
} from "../constants/config";

const safeGet = (k) => {
  try {
    return localStorage.getItem(k);
  } catch {
    return null;
  }
};
const safeSet = (k, v) => {
  try {
    localStorage.setItem(k, v);
  } catch {
    /* storage full / blocked */
  }
};

export const getAccessToken = () => safeGet(TOKEN_KEY);

export function getDeviceId() {
  let id = safeGet(DEVICE_ID_KEY);
  if (!id) {
    id =
      window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : "dev-" +
          Date.now().toString(36) +
          Math.random().toString(36).slice(2, 10);
    safeSet(DEVICE_ID_KEY, id);
  }
  return id;
}

export function readWallet() {
  try {
    return JSON.parse(safeGet(WALLET_KEY)) || null;
  } catch {
    return null;
  }
}
export function saveWallet(wallet) {
  if (wallet) safeSet(WALLET_KEY, JSON.stringify(wallet));
}

export function saveSession({ accessToken, refreshToken, userId, wallet }) {
  safeSet(TOKEN_KEY, accessToken);
  if (refreshToken) safeSet(REFRESH_TOKEN_KEY, refreshToken);
  if (userId) safeSet(USER_ID_KEY, String(userId));
  saveWallet(wallet);
  getDeviceId();
}

// logout par deviceId rehta hai (device ki pehchan), baaki sab hat jata hai
export function clearSession() {
  [TOKEN_KEY, REFRESH_TOKEN_KEY, USER_ID_KEY, WALLET_KEY].forEach((k) => {
    try {
      localStorage.removeItem(k);
    } catch {
      /* ignore */
    }
  });
}

export const SESSION_KEYS = [
  TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  USER_ID_KEY,
  DEVICE_ID_KEY,
  WALLET_KEY,
];
